export default "__VITE_ASSET__BTN2KhMI__"